import './NewIntegration.css';
import '../../aboutUs/network/Networks.css';

import IntegrationAnimation from '../../../assets/journaler/NewJournaler/integration.mov';
import binance from '../../../assets/journaler/NewJournaler/binance.svg';
import coinbase from '../../../assets/journaler/NewJournaler/coinbase.svg';
import fireblock from '../../../assets/journaler/NewJournaler/fireblock.png';
import hashkey from '../../../assets/journaler/NewJournaler/hashkey.png';
import bybit from '../../../assets/journaler/NewJournaler/bybit.png';
import quickbooks from '../../../assets/journaler/NewJournaler/quickbooks.svg';
import xero from '../../../assets/journaler/NewJournaler/xero.png';
import safe from '../../../assets/journaler/NewJournaler/safe.png';
import metamask from '../../../assets/journaler/NewJournaler/metamask.png';
import xverse from '../../../assets/journaler/NewJournaler/xverse.png';

import { Helmet } from 'react-helmet';
import ReactPlayer from 'react-player';
import { Col, Container, Row } from 'react-bootstrap';
import ButtonGroup from '../main/components/ButtonGroup';

const COPY = {
  accounting: {
    title: 'Accounting Software Integrations',
    paragraphs: [
      'Journaler integrates with Xero and QuickBooks to streamline crypto accounting, general ledger updates, and financial reporting.',
      'Automated journal entries, accurate fiat conversion, and balance syncing help accountants and businesses maintain compliant and audit-ready crypto financial records.',
    ],
  },
  exchange: {
    title: 'Exchange Integrations',
    paragraphs: [
      'Journaler supports crypto exchange integrations including Binance, Coinbase, HashKey and Bybit, enabling automatic import of trading activity, deposits, withdrawals, and fees.',
      'This simplifies crypto reconciliation, cost basis tracking, and tax reporting without manual CSV uploads.',
    ],
  },
  wallet: {
    title: 'Wallet & Custody Integrations',
    paragraphs: [
      'Journaler integrates with crypto wallets and custody platforms such as Metamask, Xverse, Fireblocks and Gnosis Safe.',
      'On-chain transactions and custody movements are recorded with full visibility, supporting institutional crypto accounting, multi-signature wallets, and audit workflows.',
    ],
  },
};

function IntegrationSectionBody({ paragraphs }) {
  return (
    <div className="integration-section-body">
      {paragraphs.map((text, i) => (
        <p key={i} className="integration-section-subtitle">
          {text}
        </p>
      ))}
    </div>
  );
}

function IntegrationCard({ logo, logoAlt, logoClassName, title, learnMoreHref }) {
  return (
    <div className="integration-card">
      <div className="integration-card-logo">
        <img src={logo} alt={logoAlt} className={logoClassName || 'integration-card-logo-img'} />
      </div>
      <div className="integration-card-title">{title}</div>
      <div className="integration-card-footer">
        {learnMoreHref ? (
          <a className="linkdetailCol" href={learnMoreHref}>
            Learn more
          </a>
        ) : (
          <span className="integration-card-footer-spacer" />
        )}
      </div>
    </div>
  );
}

const NewIntegration = () => {
  return (
    <div className="new-integration-page">
      <Helmet>
        <title>AEM Algorithm | Journaler integrations</title>
        <meta
          name="Integrations"
          content="Connect Journaler with Xero, QuickBooks, leading exchanges, and wallet & custody platforms for compliant crypto accounting."
        />
      </Helmet>

      <div className="networkHeader newIntegration text-center">
        <div className="container">
          <div className="pt-5">
            <span className="headerTitle">Integrations </span>
            <span className="headerTitleWhite">
              {' '}
              for powerful <br />
              crypto accounting
            </span>
          </div>
          <div className="subeaderTitle pt-3">
            Set up direct connections with your existing accounting systems, exchanges, <br />
            and wallet platforms with Journaler&apos;s supported integrations.
          </div>
        </div>
      </div>

      <div className="new-integration-seamless">
        <Container className="pt-5">
          <Row className="align-items-center gy-4">
            <Col xs={12} md={6}>
              <div className="new-integration-player-wrap">
                <ReactPlayer
                  url={IntegrationAnimation}
                  controls
                  muted
                  playing
                  width="100%"
                  height="100%"
                />
              </div>
            </Col>
            <Col xs={12} md={6}>
              <div>
                <span className="seamless">Seamless</span>
                <span className="crypto"> crypto accounting experience </span>
              </div>
              <div className="subtitleIntegrate pt-3">
                Connect Journaler with your accounting software and cryptocurrency exchanges.
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Container className="new-integration-body">
        <section className="new-integration-section" aria-labelledby="integration-accounting-heading">
          <div className="new-integration-section-copy">
            <h2 id="integration-accounting-heading" className="integration-section-heading">
              {COPY.accounting.title}
            </h2>
            <IntegrationSectionBody paragraphs={COPY.accounting.paragraphs} />
          </div>
          <div className="integration-card-grid integration-card-grid--two">
            <IntegrationCard
              logo={xero}
              logoAlt="Xero"
              logoClassName="integration-card-logo-img integration-card-logo-img--xero"
              title="Xero"
              learnMoreHref="/journaler/xero-integration"
            />
            <IntegrationCard
              logo={quickbooks}
              logoAlt="QuickBooks"
              logoClassName="integration-card-logo-img integration-card-logo-img--quickbooks"
              title="QuickBooks"
            />
          </div>
        </section>

        <section className="new-integration-section" aria-labelledby="integration-exchange-heading">
          <div className="new-integration-section-copy">
            <h2 id="integration-exchange-heading" className="integration-section-heading">
              {COPY.exchange.title}
            </h2>
            <IntegrationSectionBody paragraphs={COPY.exchange.paragraphs} />
          </div>
          <div className="integration-card-grid integration-card-grid--quad">
            <IntegrationCard
              logo={binance}
              logoAlt="Binance"
              logoClassName="integration-card-logo-img integration-card-logo-img--binance"
              title="Binance"
            />
            <IntegrationCard
              logo={coinbase}
              logoAlt="Coinbase"
              logoClassName="integration-card-logo-img integration-card-logo-img--coinbase"
              title="Coinbase"
            />
            <IntegrationCard
              logo={hashkey}
              logoAlt="Hashkey"
              logoClassName="integration-card-logo-img integration-card-logo-img--hashkey"
              title="Hashkey"
            />
            <IntegrationCard
              logo={bybit}
              logoAlt="Bybit"
              logoClassName="integration-card-logo-img integration-card-logo-img--bybit"
              title="Bybit"
            />
          </div>
        </section>

        <section className="new-integration-section new-integration-section--last" aria-labelledby="integration-wallet-heading">
          <div className="new-integration-section-copy">
            <h2 id="integration-wallet-heading" className="integration-section-heading">
              {COPY.wallet.title}
            </h2>
            <IntegrationSectionBody paragraphs={COPY.wallet.paragraphs} />
          </div>
          <div className="integration-card-grid integration-card-grid--quad">
            <IntegrationCard
              logo={metamask}
              logoAlt="Metamask"
              logoClassName="integration-card-logo-img integration-card-logo-img--metamask"
              title="Metamask"
            />
            <IntegrationCard
              logo={xverse}
              logoAlt="Xverse"
              logoClassName="integration-card-logo-img integration-card-logo-img--xverse"
              title="Xverse"
            />
            <IntegrationCard
              logo={fireblock}
              logoAlt="Fireblocks"
              logoClassName="integration-card-logo-img integration-card-logo-img--fireblocks"
              title="Fireblocks"
            />
            <IntegrationCard
              logo={safe}
              logoAlt="Gnosis Safe"
              logoClassName="integration-card-logo-img integration-card-logo-img--gnosis"
              title="Gnosis"
            />
          </div>
        </section>
      </Container>

      <ButtonGroup fdata={'Set up your '} gradientData={'Journaler integration'} ldata={'now'} />
    </div>
  );
};

export default NewIntegration;
